import DocPage from "src/components/docs/DocPage/DocPage";
import DocsMarkdownActions from "src/components/docs/DocsMarkdownActions";
import DocsToc from "src/components/docs/DocsToc";
import { useExtracted, useFormatter } from "#i18n";
import styles from "./DocsLayout.module.scss";
import type { DocsPageData } from "./docsPageHead";

/** A docs page: the article column (DocsLayout's grid) and, beside it, the table of contents. */
export default function DocsPageView({ data }: { data: DocsPageData }) {
  const { path, headings, content, lastUpdated } = data;
  const t = useExtracted();
  const format = useFormatter();
  return (
    <>
      <DocPage>
        {/* The compact table of contents, for narrower screens, is server-rendered above the
            article so it doesn't push the article down after hydration. */}
        <DocsToc key={path} compact headings={headings} extraContent={<DocsMarkdownActions />} />
        {content}
        {lastUpdated && (
          <p className={styles.lastUpdated}>
            {t("Last updated")}{" "}
            <time dateTime={lastUpdated}>
              {format.dateTime(new Date(lastUpdated), {
                day: "numeric",
                month: "long",
                year: "numeric",
                timeZone: "Europe/London",
              })}
            </time>
          </p>
        )}
      </DocPage>
      <DocsToc
        key={path}
        className={styles.toc}
        headings={headings}
        extraContent={<DocsMarkdownActions />}
      />
    </>
  );
}
